import * as React from 'react';

const Map = (props) => {
    let src = `https://www.google.com/maps/embed?pb=${props.coordinates}`
    return (<div className="find-us"><iframe src={src} width="600" height="450" frameBorder="0" style={{ border: 0 }} allowFullScreen></iframe></div>);
}

export default Map;